import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import CardSection from './CardSection';
import {
  Card,
  CardActions,
  CardContent,
  LinearProgress,
  Typography,
  Divider,
  Button
} from '@material-ui/core';
import clsx from 'clsx';
import {createCustomer, createPaymentMethod,getPrice} from './stripe_funcs';
import fire from '../../../../firebase';

const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  avatar: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  }
}));


const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const classes = useStyles();
  const { user } = props;
  const [price,setPrice] = useState('')
  getPrice().then((val)=>{
    console.log(val['price'])
    setPrice(val['price'])
  })
  const [loading,setLoading] = useState(false);
  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    setLoading(true)
    const cardElement = elements.getElement(CardElement);
    const price_id = 'prod_HOP42MRVFCKsqX';
    const {error, customer} = await createCustomer(user.email)
    if(error)
    {
      alert(error)
    }
    else
    {
      const result = await createPaymentMethod(cardElement,customer.id,price_id,stripe)
      if ('subscription' in result)
      {
        user['sub_id'] = result.subscription.id
        fire.database().ref('/users/'+user.uid).set(user)
      }
    }
    setLoading(false)
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card
        className={clsx(classes.root)}
      >
        <CardContent>
          <Typography
            variant="h3"
            style={{lineHeight:'2.5rem'}}
          >
            Start your subscription!
          </Typography>
          <Typography
            variant="subtitle2"
            style={{lineHeight:'1.4rem'}}
          >
            Please enter your card details below to start your subscription
          </Typography>
          <Typography
            variant="subtitle2"
            style={{lineHeight:'1.6rem'}}>
            You'll be charged {price} every 3 months.
          </Typography>
          <CardSection/>
        </CardContent>
        <Divider />
        <CardActions>
          <Button 
            type="submit"
            variant="contained"
            color="primary"
            style={{margin:'auto',width:'15rem'}}>
              Pay
          </Button>
        </CardActions>
        { loading ? <LinearProgress /> : <div></div>}
      </Card>
    </form>
  );
};

export default CheckoutForm